<template>
    <div>
        <TitleBar>
            <template v-slot:title><translate>Trips</translate></template>
            <template v-slot:buttons>
                <!-- <OnboardingIntroLink :onboarding-intro="'onboarding_web_trips'" /> -->
                <GekkoButton 
                    @click="addTrip" 
                    :text="$gettext('New')" 
                    icon="fa-solid fa-plus"
                    class="mr-2"
                />
                <GekkoButton 
                    @click="download" 
                    :text="$gettext('Download')" 
                    icon="fa-solid fa-download"
                    variant="outline-primary"
                />
            </template>
        </TitleBar>
        <div class="content">
            <TripTable />
        </div>
    </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import TripTable from "@/components/trips/TripTable"
import GekkoButton from "@/components/GekkoButton";
// import OnboardingIntroLink from "@/components/ui/OnboardingIntroLink"

export default {
    name: 'Trips',
    components: { 
        TitleBar, 
        TripTable, 
        GekkoButton,
        // OnboardingIntroLink
    },
    data() {
        return {
            
        }
    },
    methods: {
        addTrip() {
            this.$router.push({name: 'AddTrip'});
        },
        download() {
            let filters = this.$store.getters['filterStore/getFilter'];
            let queryString = this.encodeQueryData(filters);
            let url = window.Urls['trips_export_trips']();
            if (queryString)
                url += "?" + queryString;
            window.location.href = url;
        },
        encodeQueryData(data) {
            var ret = [];
            for (var d in data)
                if (data[d]) {
                    ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
                }
            return ret.join("&");
        }
    }
}
</script>

<style scoped>

</style>